/** Shared intake scroll / focus helpers for form UX. */

function prefersReducedMotion() {
  try {
    return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches)
  } catch (e) {
    return false
  }
}

function scrollBehavior() {
  return prefersReducedMotion() ? 'auto' : 'smooth'
}

export function getIntakeScrollRoot(fromEl) {
  if (fromEl && fromEl.closest) {
    const shell = fromEl.closest('.rb-auth-shell')
    if (shell) {
      return shell
    }
  }
  return document.querySelector('.rb-ob-layout .rb-auth-shell') || document.scrollingElement || document.documentElement
}

/** After Continue / route change — bring the new step into view. */
export function scrollIntakeToTop(fromEl) {
  const root = getIntakeScrollRoot(fromEl)
  const behavior = scrollBehavior()
  if (!root) {
    return
  }
  if (typeof root.scrollTo === 'function') {
    root.scrollTo({top: 0, left: 0, behavior})
    return
  }
  root.scrollTop = 0
}

/** Move keyboard focus to the step title after navigation (screen-reader friendly). */
export function focusIntakeStepTitle(fromEl) {
  const scope = fromEl || document.querySelector('.rb-ob-layout') || document
  const title = scope.querySelector('main h1, main .rb-ob-title, .rb-ob-form h1, .rb-ob-form .rb-ob-title')
  if (!title) {
    return
  }
  if (!title.hasAttribute('tabindex')) {
    title.setAttribute('tabindex', '-1')
  }
  try {
    title.focus({preventScroll: true})
  } catch (e) {
    title.focus()
  }
}

function firstFocusable(block) {
  if (!block || !block.querySelector) {
    return null
  }
  return block.querySelector(
    'input:not([type="hidden"]):not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), [tabindex]:not([tabindex="-1"])',
  )
}

/** After validation fails — move to the first invalid field in document order. */
export function scrollIntakeToInvalid(fromEl) {
  const scope = fromEl || document.querySelector('.rb-ob-layout .rb-ob-form') || document
  const block = scope.querySelector('.is-invalid')
  if (!block) {
    return false
  }

  block.classList.remove('is-attention')
  // force reflow so the attention animation can retrigger
  void block.offsetWidth
  block.classList.add('is-attention')

  const behavior = scrollBehavior()
  if (typeof block.scrollIntoView === 'function') {
    block.scrollIntoView({behavior, block: 'center', inline: 'nearest'})
  }

  const focusEl = firstFocusable(block)
  if (focusEl && typeof focusEl.focus === 'function') {
    try {
      focusEl.focus({preventScroll: true})
    } catch (e) {
      focusEl.focus()
    }
  }

  window.setTimeout(() => {
    block.classList.remove('is-attention')
  }, 1200)

  return true
}
